module.exports = __webpack_public_path__ + "static/assets/9fecb3b6207ebd9cd8d85f5bb82cbaec.svg";